import React, { Component } from 'react'
import { createPortal } from 'react-dom'

export class IFrame extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mountNode: null
        }
        this.setContentRef = (contentRef) => {
            this.setState({
                mountNode: contentRef ?.contentWindow ?.document ?.body
      })
        }


    }

    componentDidMount = () => {
        window.setTimeout(function () {
            var css = 'td {padding:5px; border:1px solid black;  border-collapse: collapse} table{width:100%; margin-bottom:50px}',
                style = document.createElement('style');

            window.frames['printf'].document.head.appendChild(style);

            style.type = 'text/css';
            if (style.styleSheet) {
                // This is required for IE8 and below.
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }
        }, 1000);

    }

    appendCSS = () => {
        var css = 'td {padding:5px; border:1px solid black;  border-collapse: collapse} table{width:100%; margin-bottom:50px}',
            style = document.createElement('style');

        window.frames['printf'].document.head.appendChild(style);

        style.type = 'text/css';
        if (style.styleSheet) {
            // This is required for IE8 and below.
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }


    }


  render() {
    const { children, ...props } = this.props
    const { mountNode } = this.state
    return (
      <iframe
            {...props}
            ref={this.setContentRef}
            //onLoad={()=>this.appendCSS()}
        >

            {mountNode && createPortal(children, mountNode)}
      </iframe>
    )
  }
}
